import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featuredArticles = articles.filter((a) => a.isFeatured);
  const editorPicks = articles.filter((a) => a.isEditorPick && !a.isFeatured);
  const latestArticles = articles.filter((a) => !a.isFeatured && !a.isEditorPick).slice(0, 6);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            精选内容推荐
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed">
            编辑团队精心筛选的高质量内容，涵盖科技、生活、商业、人文等热门领域的深度好文。
          </p>
        </div>

        <div className="space-y-6 mb-12">
          {featuredArticles.map((article) => (
            <ArticleCard key={article.slug} article={article} variant="featured" />
          ))}
        </div>

        {editorPicks.length > 0 && (
          <div className="mb-10">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-6 h-6 flex items-center justify-center rounded bg-accent-500 text-white">
                <i className="ri-check-double-line text-xs"></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-900">编辑精选</h3>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {editorPicks.map((article) => (
                <ArticleCard key={article.slug} article={article} />
              ))}
            </div>
          </div>
        )}

        <div className="mb-10">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 flex items-center justify-center rounded bg-secondary-500 text-white">
                <i className="ri-time-line text-xs"></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-900">最新文章</h3>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {latestArticles.map((article) => (
              <ArticleCard key={article.slug} article={article} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}